import { useEffect } from "react";
import { useDispatch, useSelector, aclActions } from "src/redux/store";
import LoadingMask from "src/components/loadingMask";
import permissions from "./permissions.json";

const Acl = ({ children }) => {
    const dispatch = useDispatch();
    const { keycloak } = useSelector((state) => state.keycloakReducer);
    const { functions } = useSelector((state) => state.aclReducer);

    const getAcl = async () => {
        if (!Object.keys(keycloak).length) return;
        dispatch(aclActions.setFunctions(permissions));
    };

    useEffect(() => {
        getAcl();
    }, [keycloak]);

    return Object.keys(keycloak).length && functions.length ? children : <LoadingMask />;
};
export default Acl;